import * as React from "react";
import TextField from "@mui/material/TextField";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment from "moment";
import dayjs from "dayjs";
const Datetimepicker = (props: any) => {
  const { data, change, node } = props;
  const [showTooltip, setShowTooltip] = React.useState(false);

  const handleChange = (nodess: any) => {
    let updateData = [...data];
    let filter;
    filter = updateData.filter((n: any) => {
      return n.name === node.name;
    });

    if (filter[0] && nodess && nodess.$d !== "Invalid date") {
      const formattedDate = moment(nodess?.$d).format("YYYY-MM-DD HH:mm:ss");
      filter[0].value = formattedDate;

      if (node?.reference?.items) {
        const refNode = updateData.find(
          (n: any) => n.name === node.reference.items,
        );
        const operator = node?.reference?.condition?.operator;
        const maxMonths = node?.reference?.maxRangeMonths;

        if (refNode) {
          const selectedDayjs = dayjs(nodess.$d);
          const currentRefDayjs = refNode.value ? dayjs(refNode.value) : null;

          if (operator === "<") {
            // `node` is "From" date, `refNode` is "To" date
            if (maxMonths) {
              const maxToDate = selectedDayjs
                .add(maxMonths, "month")
                .endOf("day");
              const todayEnd = dayjs().endOf("day");
              const effectiveMaxToDate = maxToDate.isBefore(todayEnd)
                ? maxToDate
                : todayEnd;

              if (
                !currentRefDayjs ||
                !currentRefDayjs.isValid() ||
                currentRefDayjs.isBefore(selectedDayjs) ||
                currentRefDayjs.isAfter(maxToDate)
              ) {
                refNode.value = moment(effectiveMaxToDate.toDate()).format(
                  "YYYY-MM-DD HH:mm:ss",
                );
              }
            } else {
              // No maxRangeMonths restriction: only ensure To date is not before From date
              if (
                !currentRefDayjs ||
                !currentRefDayjs.isValid() ||
                currentRefDayjs.isBefore(selectedDayjs)
              ) {
                const todayEnd = dayjs().endOf("day");
                const targetTo = selectedDayjs.endOf("day").isBefore(todayEnd)
                  ? selectedDayjs.endOf("day")
                  : todayEnd;
                refNode.value = moment(targetTo.toDate()).format(
                  "YYYY-MM-DD HH:mm:ss",
                );
              }
            }
          } else if (operator === ">") {
            // `node` is "To" date, `refNode` is "From" date
            if (maxMonths) {
              const calculatedMinFromDate = selectedDayjs
                .subtract(maxMonths, "month")
                .startOf("day");
              const minLimit = dayjs("2000-01-01 00:00:00");
              const minFromDate = calculatedMinFromDate.isBefore(minLimit)
                ? minLimit
                : calculatedMinFromDate;

              if (
                !currentRefDayjs ||
                !currentRefDayjs.isValid() ||
                currentRefDayjs.isAfter(selectedDayjs) ||
                currentRefDayjs.isBefore(minFromDate)
              ) {
                refNode.value = moment(minFromDate.toDate()).format(
                  "YYYY-MM-DD HH:mm:ss",
                );
              }
            } else {
              // No maxRangeMonths restriction: only ensure From date is not after To date
              if (
                !currentRefDayjs ||
                !currentRefDayjs.isValid() ||
                currentRefDayjs.isAfter(selectedDayjs)
              ) {
                const targetFrom = selectedDayjs.startOf("day");
                const minLimit = dayjs("2000-01-01 00:00:00");
                const effectiveFrom = targetFrom.isBefore(minLimit)
                  ? minLimit
                  : targetFrom;
                refNode.value = moment(
                  effectiveFrom.toDate(),
                ).format("YYYY-MM-DD HH:mm:ss");
              }
            }
          }
        }
      }
    } else if (nodess === null && filter[0]) {
      filter[0].value = "";
    }

    change([...updateData]);
  };
  const onkeydown = (e: any) => {
    e.preventDefault();
  };
  const checkMaxMinDate = (direction: "min" | "max") => {
    if (direction === "min") {
      if (node?.minDate) {
        return dayjs(node.minDate);
      }
      return dayjs("2000-01-01");
    }

    if (direction === "max") {
      if (node?.maxDate) {
        return dayjs(node.maxDate);
      }
      return dayjs();
    }

    return null;
  };
  return (
    <div id={`date_time_${node?.title}`} className="relative">
      {node?.infoText && (
        <div className="flex items-center justify-between mb-1 px-0.5">
          <span className="text-xs font-semibold text-[#565656]">
            {node.title}
          </span>
          <div
            className="relative flex items-center"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setShowTooltip(!showTooltip);
              }}
              className="text-[#2563EB] hover:bg-[#EFF6FF] p-0.5 rounded-full flex items-center transition-colors cursor-pointer"
              title="Date Range Limit Info"
            >
              <svg
                className="w-3.5 h-3.5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </button>

            {showTooltip && (
              <div className="absolute right-0 top-5 z-[99999] w-64 p-3 bg-[#FFFFFF] border border-[#DBEAFE] rounded-lg shadow-xl text-xs text-[#1E293B] leading-relaxed transition-all duration-200">
                <div className="flex items-center gap-1.5 font-semibold text-[#1E3A8A] mb-1">
                  <svg
                    className="w-3.5 h-3.5 text-[#2563EB]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Date Range Limit
                </div>
                <p className="mb-1 text-[#1E293B] font-medium text-[11px]">
                  Search is currently limited to a maximum of 3 months for any selected period.
                </p>
                <p className="text-[#64748B] text-[10px]">
                  The next release will restore the search range to one year.
                </p>
              </div>
            )}
          </div>
        </div>
      )}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          disabled={node.disabled || false}
          className={`${node.disabled ? "bg-[#aaaaaa1d]" : ""}`}
          minDate={checkMaxMinDate("min")}
          maxDate={checkMaxMinDate("max") || dayjs()}
          renderInput={(params) => (
            <TextField
              {...params}
              onKeyDown={(e: any) => {
                onkeydown(e);
              }}
            />
          )}
          value={node?.value ? dayjs(node.value) : null}
          label={node?.infoText ? undefined : node?.title}
          onChange={handleChange}
        />
      </LocalizationProvider>
    </div>
  );
};

export default Datetimepicker;
